import { ReactNode } from "react";

export const MobileWrapper = ({ children }: { children: ReactNode }) => {
  return <div>{children}</div>;
};
